import { stats } from "@/mocks/manhwa";

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[720px] w-full items-center overflow-hidden md:min-h-[760px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20stylized%20manhwa%20illustration%20collage%20of%20vibrant%20comic%20characters%20and%20dynamic%20ink%20splashes%20in%20warm%20vermillion%20orange%20amber%20and%20cream%20tones%2C%20action%20silhouettes%20and%20floating%20comic%20panels%2C%20epic%20dramatic%20lighting%2C%20high%20detail%20digital%20art%2C%20artistic%20abstract%20composition&width=1600&height=900&seq=hero-korean-manhwa&orientation=landscape"
          alt="虚空韩漫网韩漫追更平台背景插画"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-background-50"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-24 pt-28 md:px-6 md:pb-32">
        <div className="mx-auto w-full max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-100/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-accent-200 backdrop-blur-sm md:text-sm">
            <i className="ri-flashlight-fill text-sm"></i>
            最新话追更进度 · 连载更新提醒
          </span>
          <h1 className="font-heading mt-6 text-4xl font-black leading-tight text-background-50 md:text-6xl">
            韩漫追更，<br className="md:hidden" />
            从这里开始
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-lg">
            虚空韩漫网同步热门韩漫最新话与连载进度，新作上线即时标记。追更列表自动提醒，打开就能看到每部作品更新到哪，不再错过任何一话。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#updates"
              className="inline-flex h-12 w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-8 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto md:text-base"
            >
              <i className="ri-flashlight-fill text-lg"></i>
              查看最新更新
            </a>
            <a
              href="#schedule"
              className="inline-flex h-12 w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-100/40 bg-background-50/10 px-8 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 sm:w-auto md:text-base"
            >
              <i className="ri-calendar-check-line text-lg"></i>
              周更进度表
            </a>
          </div>
        </div>

        <div className="mx-auto mt-14 grid w-full max-w-4xl grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-background-100/20 bg-background-50/10 px-4 py-5 text-center backdrop-blur-sm"
            >
              <div className="font-heading text-2xl font-black text-accent-300 md:text-3xl">{s.value}</div>
              <div className="mt-1 text-xs text-background-100 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}